export default function(location) {
	let split = location.pathname.split('/instruments/');
	if (split.length === 1) {
		split = location.pathname.split('/instrument/');
	}
	return split.length > 1 ? split[1].split('/')[0] : undefined;
}
